var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOutscanShipment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1615_26848)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1615_26848)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_1615_26848)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70 0H9.2C4.11898 0 0 4.11898 0 9.2V70C0 75.081 4.11898 79.2 9.2 79.2H70C75.081 79.2 79.2 75.081 79.2 70V9.2C79.2 4.11898 75.081 0 70 0Z",
    fill: "#F8FBFF",
    stroke: "#F0F2F5",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5682 54.0664H10.7139V36.5523H30.5682V54.0664Z",
    fill: "#F9D044"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.8701 54.0664H30.5684V36.5523H37.8701V54.0664Z",
    fill: "#F3922B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3019 45.5996L20.6547 44.6195L20.0447 44.2661L21.6272 41.5232L20.1712 40.6812L18.5856 43.4241L17.9756 43.0716L18.3019 45.5996Z",
    fill: "#F3922B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3962 48.3901L19.3683 46.8437V47.5491H16.2017V49.2326H19.3683V49.9375L21.3962 48.3901Z",
    fill: "#F3922B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2463 44.3096L21.9199 46.8386L22.5314 46.4851L24.1145 49.2285L25.5716 48.3875L23.9885 45.6442L24.5995 45.2917L22.2463 44.3096Z",
    fill: "#F3922B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3269 44.4696L21.7845 41.796L21.6389 42.0471L20.812 43.479L21.8478 45.2734L22.022 43.9249L23.3269 44.4696Z",
    fill: "#F3922B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8998 44.6078L16.3584 47.2773H18.3034L19.3553 45.4533L18.078 45.986L17.8998 44.6078Z",
    fill: "#F3922B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7454 49.2285H23.8015L22.8295 47.545L20.7358 47.546L21.8429 48.3905L20.7454 49.2285Z",
    fill: "#F3922B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0246 42.457H12.2935V38.9229H17.0246V42.457Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3606 41.6348H12.8184V39.7489H13.3606V41.6348Z",
    fill: "#37559B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8621 41.6348H15.3184V39.7489H15.8621V41.6348Z",
    fill: "#37559B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0397 41.6348H14.3252V39.7489H15.0397V41.6348Z",
    fill: "#37559B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1159 41.6348H13.8442V39.7489H14.1159V41.6348Z",
    fill: "#37559B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5006 41.6348H16.229V39.7489H16.5006V41.6348Z",
    fill: "#37559B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.7254 54.0293H37.8696V36.5157H57.7254V54.0293Z",
    fill: "#F9D044"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.0284 54.0293H57.7256V36.5157H65.0284V54.0293Z",
    fill: "#F3922B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.4587 45.5625L47.8124 44.5814L47.2014 44.2275L48.7855 41.4851L47.3279 40.6436L45.7434 43.387L45.1323 43.0335L45.4587 45.5625Z",
    fill: "#F3922B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.5534 48.3549L46.526 46.808V47.5134H43.3584V49.1959H46.526V49.9023L48.5534 48.3549Z",
    fill: "#F3922B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.4044 44.272L49.0791 46.8005L49.6896 46.4475L51.2722 49.1914L52.7298 48.3499L51.1462 45.6065L51.7587 45.2536L49.4044 44.272Z",
    fill: "#F3922B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.4871 44.4286L48.9417 41.7555L48.7972 42.0061L47.9702 43.438L49.007 45.2324L49.1812 43.8838L50.4871 44.4286Z",
    fill: "#F3922B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.057 44.5707L43.5151 47.2402H45.4597L46.5131 45.4162L45.2353 45.9489L45.057 44.5707Z",
    fill: "#F3922B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9046 49.1914H50.9593L49.9872 47.5074H47.8936L49.0007 48.3534L47.9046 49.1914Z",
    fill: "#F3922B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.1813 42.4219H39.4507V38.8882H44.1813V42.4219Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5179 41.5957H39.9751V39.7104H40.5179V41.5957Z",
    fill: "#37559B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0199 41.5957H42.4751V39.7104H43.0199V41.5957Z",
    fill: "#37559B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.1973 41.5957H41.4849V39.7104H42.1973V41.5957Z",
    fill: "#37559B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.2736 41.5957H41.0024V39.7104H41.2736V41.5957Z",
    fill: "#37559B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.6598 41.5957H43.3867V39.7104H43.6598V41.5957Z",
    fill: "#37559B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.1463 36.5137H24.293V18.9986H44.1463V36.5137Z",
    fill: "#F9D044"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.4498 36.5137H44.146V18.9986H51.4498V36.5137Z",
    fill: "#F3922B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8816 28.0469L34.2348 27.0653L33.6228 26.7118L35.2068 23.9685L33.7493 23.1275L32.1652 25.8709L31.5542 25.5179L31.8816 28.0469Z",
    fill: "#F3922B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.9738 30.8388L32.9479 29.2919V29.9978H29.7808V31.6808H32.9479V32.3867L34.9738 30.8388Z",
    fill: "#F3922B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.8254 26.7569L35.499 29.2854L36.109 28.9319L37.6931 31.6758L39.1507 30.8338L37.5671 28.0909L38.1791 27.7385L35.8254 26.7569Z",
    fill: "#F3922B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9071 26.9144L35.3632 24.2409L35.2186 24.4909L34.3906 25.9243L35.4269 27.7188L35.6011 26.3702L36.9071 26.9144Z",
    fill: "#F3922B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4779 27.0565L29.937 29.7266H31.8811L32.935 27.903L31.6561 28.4352L31.4779 27.0565Z",
    fill: "#F3922B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.325 31.6758H37.3796L36.4081 29.9918H34.3145L35.4215 30.8373L34.325 31.6758Z",
    fill: "#F3922B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6027 24.9043H25.8726V21.3706H30.6027V24.9043Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9392 24.082H26.3955V22.1962H26.9392V24.082Z",
    fill: "#37559B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4407 24.082H28.8975V22.1962H29.4407V24.082Z",
    fill: "#37559B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6182 24.082H27.9053V22.1962H28.6182V24.082Z",
    fill: "#37559B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.695 24.082H27.4219V22.1962H27.695V24.082Z",
    fill: "#37559B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0798 24.082H29.8071V22.1962H30.0798V24.082Z",
    fill: "#37559B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.3775 56.0293H7V54.0672H72.3775V56.0293Z",
    fill: "#D1671C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3604 60H7V56.029H13.3604V60Z",
    fill: "#F3922B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1162 60H21.7549V56.029H28.1162V60Z",
    fill: "#F3922B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.8686 60H36.5093V56.029H42.8686V60Z",
    fill: "#F3922B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.6236 60H51.2637V56.029H57.6236V60Z",
    fill: "#F3922B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.3774 60H66.0176V56.029H72.3774V60Z",
    fill: "#F3922B"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1615_26848"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1615_26848"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_1615_26848"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutscanShipment);
export default __webpack_public_path__ + "static/media/outscanShipment.a6732309b7a04bd1636eee83c09db8fa.svg";
export { ForwardRef as ReactComponent };